import React from 'react';
import { getSEOUrl } from '../utilities/helpers/seoHelpers';

// render the SEO section on the news directory
const SEOSection = (props) => {
    if (!props.showSEOSection) {
        return null;
    }

    return (
        <section className="seo_container">
            <div className="row">
                <div className="col">
                    {renderCountriesSection(props)}
                </div>
                <div className="col">
                    {renderCategoriesByCountrySection(props)}
                </div>
            </div>
            <div className="row">
                <div className="col" style={{ paddingTop: 15, paddingBottom: 10 }}>
                    <p>{props.page_description}</p>
                </div>
            </div>
        </section>
    )
}

// render the countries list on the SEO section
const renderCountriesSection = (props) => {
    const { location_seo, category_seo, categories_seo } = props;
    let list = [];
    const countryName = location_seo.name;
    const isoCode = location_seo.iso_code;

    if (category_seo) {
        const categoryId = category_seo.id;

        categories_seo.map(
            cat => {
                if (cat.id != categoryId) {
                    let link = getSEOUrl('news', isoCode, cat.code);
                    list.push(<li key={cat.id}><a href={link}>{`${cat.name} in ${countryName}`}</a></li>);
                }
            }
        )
    } else {
        categories_seo.map(
            cat => {
                let link = getSEOUrl('news', isoCode, cat.code);
                list.push(<li key={cat.id}><a href={link}>{`${cat.name} in ${countryName}`}</a></li>);
            }
        )
    }

    return <ul style={{ fontSize: 14, listStyle: 'none' }}>
        <li><h1>News by Category</h1></li>
        {list}
    </ul>
}

// render the categories by country list on the SEO section
const renderCategoriesByCountrySection = (props) => {
    const { location_seo, category_seo, locations_seo } = props;
    let list = [];

    if (category_seo) {
        const typeName = category_seo.name;
        const typeCode = category_seo.code;

        locations_seo.map(
            location => {
                if (location.id != location_seo.id) {
                    let link = getSEOUrl('news', location.iso_code, typeCode);
                    list.push(<li key={location.id}><a href={link}>{`${typeName} in ${location.name}`}</a></li>);
                }
            }
        )
    } else {
        locations_seo.map(
            location => {
                if (location.id != location_seo.id) {
                    let link = getSEOUrl('news', location.iso_code);
                    list.push(<li key={location.id}><a href={link}>{`News in ${location.name}`}</a></li>);
                }
            }
        )
    }

    return <ul style={{ fontSize: 14, listStyle: 'none' }}>
        <li><h1>News by Country</h1></li>
        {list}
    </ul>
}

export default SEOSection;